export const SET_STATE = '@docs-emission/SET_STATE';
